<template>
  <svg @mouseover="openTooltip" @mouseout="closeTooltip" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" :width="size" :height="size" viewBox="0 0 47 47">
    <defs>
      <filter id="Ellipse_6" x="0" y="0" width="47" height="47" filterUnits="userSpaceOnUse">
        <feOffset dy="3" input="SourceAlpha"/>
        <feGaussianBlur stdDeviation="3" result="blur"/>
        <feFlood flood-opacity="0.161"/>
        <feComposite operator="in" in2="blur"/>
        <feComposite in="SourceGraphic"/>
      </filter>
    </defs>
    <g id="Component_25_7" data-name="Component 25 – 7" transform="translate(9 6)">
      <g transform="matrix(1, 0, 0, 1, -9, -6)" v-if="shadow" filter="url(#Ellipse_6)">
        <circle id="Ellipse_6-2" data-name="Ellipse 6" cx="14.5" cy="14.5" r="14.5" transform="translate(9 6)" fill="#f23411"/>
      </g>
      <g transform="matrix(1, 0, 0, 1, -9, -6)" v-else>
        <circle id="Ellipse_6-2" data-name="Ellipse 6" cx="14.5" cy="14.5" r="14.5" transform="translate(9 6)" fill="#f23411"/>
      </g>
      <text id="_" data-name="!" transform="translate(3 1.6)" fill="#fff" font-size="21" font-family="Yrsa-Bold, Yrsa" font-weight="700"><tspan x="8.791" y="20">!</tspan></text>
    </g>
  </svg>
</template>


<script>
import {EventBus} from '@/event-bus.js'

export default {
  'name': 'concerning-developments',
  'props': {
    'size': {
      type: Number,
      default: 47
    },
    'shadow': {
      type: Boolean,
      default: true
    }
  },
  destroyed () {
    EventBus.$emit('tooltip.hide')
  },
  methods: {
    openTooltip () {
      EventBus.$emit('tooltip.show', {
        style: 'multiline',
        label: 'Concerning developments',
        value: [
          '<span class="text-sm">' + this.$Strings('covid19_concerning_tooltip') + '</span>'
        ]
      })
    },
    closeTooltip () {
      EventBus.$emit('tooltip.hide')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/icons/ConcerningDevelopments.vue